module.exports = __webpack_public_path__ + "img/Home_Bild1.0e70d65f.jpg";